const view = "wellness_plan";

export const EVENTS = {
  selectWellnessPlan: {
    view,
    event: "select_wellness_plan_clicked",
  },
  viewEntitlements: {
    view,
    event: "view_entitlements_clicked",
  },
  selectNoPlan: {
    view,
    event: "select_no_plan_clicked",
  },
  chooseAnotherPlan: {
    view,
    event: "choose_another_plan_clicked",
  },
  viewTermsAndConditions: {
    view,
    event: "view_terms_and_conditions_clicked",
  },
};
